var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ion-content',{attrs:{"main":""}},[(!_vm.noBack.find(function (path) { return path === _vm.$route.path; }))?_c('back-arrow'):_vm._e(),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }